export default "__VITE_ASSET__Cc2hrG9D__"